export default __webpack_public_path__ + "static/media/blogcard1.2739a832.png";